// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7022) FIXME: 'TopLinksController' implicitly has type 'any' bec... Remove this comment to see the full error message
var TopLinksController = (function() {
   let NAV_PATHS: any = undefined
   TopLinksController = class TopLinksController {
      $location: any
      $scope: any
      $timeout: any
      i18n: any
      config: ConfigService
      researchAssistantService: ResearchAssistantService
      static initClass() {  
         NAV_PATHS = {
            'Home': {
               path: '/search',
               view: 'search'
            },
            'Course Reserves': {
               path: '/course_reserves',
               view: 'course_reserves'
            }
         }
      }

      constructor($scope: any, $location: any, config: ConfigService, $timeout: any, i18n: any, researchAssistantService: ResearchAssistantService) {
         this.$scope = $scope
         this.$location = $location
         this.$timeout = $timeout
         this.i18n = i18n
         this.config = config
         this.researchAssistantService = researchAssistantService
         this.$scope.goToPath = this.goToPath.bind(this)
         this.$scope.paths = NAV_PATHS
         this.$scope.navEnabled = !!this.config.data.alma.api_key.trim()
         this.$scope.isResearchAssistantEnabled = this.researchAssistantService.isResearchAssistantEnabled
         this.$scope.i18n = this.i18n
      }

      goToPath(route: any, cb = angular.noop){
         cb()
         return this.$location.path(route)
      }

   }
   TopLinksController.initClass()
   return TopLinksController
})()



TopLinksController.$inject = ['$scope', '$location', 'configService', '$timeout', 'translationService', 'researchAssistantService']

angular.module('summonApp.controllers')
   .controller('TopLinksCtrl', TopLinksController)
